export default __webpack_public_path__ + "static/cleanroom-110440aa90f33562fa111fcd88da8d7b.jpg";